import React, { ReactChild } from 'react';
// @ts-ignore
import { useTabIndex } from 'react-tabindex';
import styled from 'styled-components';

type Props = {
  children: ReactChild | ReactChild[];
  isLoading?: boolean;
  ref?: React.RefObject<HTMLButtonElement>;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const StyledButton = styled.button`
  width: 100%;
  font-size: var(--bs-sm-font-size);
  border-radius: var(--bs-pill-radius);
  background: var(--bs-p-navy-btn-bg);
  padding: 15px;
  color: var(--bs-p-navy-btn-text);
  text-transform: uppercase;
  font-weight: var(--weight-bold);

  &:hover {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }

  &[disabled] {
    cursor: not-allowed;
    width: 100%;
    font-size: var(--bs-sm-font-size);
    border-radius: var(--bs-pill-radius);
    background: #8f98ac;
    padding: 15px;
    color: var(--bs-t-text);
    text-transform: uppercase;
    font-weight: var(--weight-bold);
  }

  @media (max-width: 767px) {
    padding: 10px 15px;
    width: 80%;
  }
`;

const Button = (props: Props) => {
  const { children, ...buttonProps } = props;
  const isDisabled =
    typeof props.disabled === 'boolean'
      ? props.disabled
      : Boolean(props.isLoading);
  const tabIndex: number = useTabIndex();
  return (
    <StyledButton tabIndex={tabIndex} {...buttonProps} disabled={isDisabled}>
      {children}
    </StyledButton>
  );
};

export default Button;
